// @flow
import type { IConstraintModel } from "../../types";

/**
 */
class BSNConstraint implements IConstraintModel {
  /**
   */
  get id(): string {
    return "Constraint.BSN.InvalidFormat";
  }

  /**
   */
  hasValidation(): boolean {
    return true;
  }

  /**
   */
  get defaultMessage(): string {
    return "Must be a valid BSN";
  }

  /**
   */
  get parameters(): { ... } {
    return {};
  }

  /**
   */
  isValidBSN(bsn: string): boolean {
    // if remove invalid characters and check if this is still the same length to find out if unwanted characters are used
    // valid characters are: numbers
    if (bsn.replace(/[^\d]/gu, "").length !== bsn.length) {
      return false;
    }

    const bsnNumber = bsn.replace(/\D/gu, "");

    const bsnLength = bsnNumber.length;
    const MINBSNLENGTH = 8;
    const MAXBSNLENGTH = 9;

    if (
      bsnLength < MINBSNLENGTH ||
      bsnLength > MAXBSNLENGTH ||
      isNaN(bsnNumber)
    ) {
      return false;
    }

    let pos = 0;
    let result = 0;

    for (let i = bsnLength; i > 0; i--) {
      const digit = parseInt(bsnNumber.charAt(pos), 10);

      result += i === 1 ? digit * -1 : digit * i;
      pos += 1;
    }

    return result % 11 === 0;
  }

  /**
   */
  validate(value: string): boolean {
    return this.isValidBSN(value);
  }

  /**
   */
  get isMandatoryConstraint(): boolean {
    return false;
  }
}

export default BSNConstraint;
